const STORAGE_KEY = "camping_guest_portal_session";

export type GuestProfile = {
  id: string;
  first_name: string;
  last_name: string;
  email: string | null;
  phone: string | null;
  street: string | null;
  postal_code: string | null;
  city: string | null;
  country_code: string;
  license_plate: string | null;
  license_plate_country: string | null;
  vehicle_type: string | null;
};

export type GuestSession = {
  expires_at: string;
  guest: GuestProfile;
};

export function loadGuestSession(): GuestSession | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GuestSession;
    if (!parsed.guest) return null;
    if (parsed.expires_at && new Date(parsed.expires_at).getTime() < Date.now()) {
      clearGuestSession();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveGuestSession(session: GuestSession): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearGuestSession(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
